import React, { createContext, useContext, useState, useMemo } from 'react';
import debounce from 'lodash/debounce';

const SearchMyCourseContext = createContext();

function SearchMyCourseProvider({ children }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');

  const handleSearchTermChange = useMemo(() => {
    const debouncedSave = debounce((searchMessage) => setDebouncedSearchTerm(searchMessage));

    return (searchMessage) => {
      setSearchTerm(searchMessage);
      debouncedSave(searchMessage);
    };
  }, []);

  const resetSearchTerm = () => {
    setSearchTerm('');
    setDebouncedSearchTerm('');
  };

  const updateSearchTerm = (searchMessage) => {
    setSearchTerm(searchMessage);
    setDebouncedSearchTerm(searchMessage);
  };

  return (
    <SearchMyCourseContext.Provider
      value={{
        searchTerm,
        setSearchTerm,
        debouncedSearchTerm,
        setDebouncedSearchTerm,
        handleSearchTermChange,
        resetSearchTerm,
        updateSearchTerm,
      }}
    >
      {children}
    </SearchMyCourseContext.Provider>
  );
}

function useSearchMyCourseProvider() {
  const context = useContext(SearchMyCourseContext);
  if (context === undefined) {
    throw new Error('useSearchMyCourseProvider must be used within SearchMyCourseProvider');
  }
  return context;
}

export { useSearchMyCourseProvider };
export default SearchMyCourseProvider;
